<template>

    <div>

        <v-data-table :loading="isLoading"
                      :headers="headers"
                      :items="allList" sort-by="calories" class="elevation-1" hide-default-footer>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>File</v-toolbar-title>
                    <v-divider class="mx-4" inset vertica></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark
                           class="mb-2"
                           v-on:click="showAddFileDialog(true)">New File
                    </v-btn>
                    <v-dialog v-model="addEditDialog" max-width="500px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :rules="[rules.required]" v-model="editedItem.name"
                                                          label="File Name"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :readonly="true" v-model="editedItem.size"
                                                          label="File Size"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :readonly="true" v-model="editedItem.length"
                                                          label="File Length"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>

                <v-text-field
                        v-on:keyup.enter="searchAll"
                        v-model="search"
                        label="Search"
                        single-line
                        hide-details
                        class="pb-3 px-3"
                ></v-text-field>
            </template>


            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon small class="mr-2" @click="fileDownload(item)">
                    mdi-download
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
        <pagination :page="page" :total-page="totalPage" @paginate="paginate($event)"></pagination>
        <file-input @fileUploaded="fileUploaded($event)" :show="shouldShowAddDialog"
                    @closeDialog="showAddFileDialog(false)"></file-input>

    </div>
</template>


<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import {FileService} from "../../services/file.service";
    import Pagination from '../../components/Pagination'
    import NewFileDialog from '../../components/dialog/NewFileDialog'

    export default {
        name: "FilePanel",
        components: {
            Pagination,
            'file-input':NewFileDialog
        },
        data: () => ({
            loading: false,
            search: '',
            addFileDialog: false,
            rules: {
                required: value => !!value || 'Required.'
            },
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {text: 'Size', value: 'size', sortable: false},
                {text: 'Length', value: 'length', sortable: false},
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                size: 0,
                length: 0,
                parseItem: null
            },
            defaultItem: {
                name: '',
                size: 0,
                length: 0,
                parseItem: null
            }
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New File' : 'Edit File'
            },
            page() {
                return this.getPagination().page;
            },
            perPage() {
                return this.getPagination().perPage;
            },
            totalPage() {
                return this.getPagination().totalPage;
            },
            allList() {
                return this.getAll();
            },
            isLoading() {
                return this.getLoading()
            },
            shouldShowAddDialog(){
                return this.getShowAddDialog()
            },
            addEditDialog: {
                get() {
                    return this.showAddEditDialog();
                },
                set(value) {
                    this.setShowAddEditDialog(value);
                }
            }
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.initialize()
        },
        methods: {
            ...mapMutations({
                setShowAddEditDialog: 'file/SHOW_ADD_EDIT_DIALOG',
                setShowAddFileDialog: 'file/SET_SHOW_ADD_DIALOG',
            }),
            ...mapGetters({
                getPagination: 'file/getPagination',
                getLoading: 'file/getLoading',
                getAll: 'file/getAll',
                getShowAddDialog: 'file/getShowAddDialog',
                showAddEditDialog: 'file/showAddEditDialog'
            }),
            ...mapActions({
                requestAll: 'file/requestAll',
                setPage: 'file/setPage',
                setSearch: 'file/setSearch',
                setSave: 'file/setSave',
                setEdit: 'file/setEdit'
            }),
            initialize() {
                this.requestAll();
            },
            newItem() {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.setShowAddEditDialog(true);
            },
            editItem(item) {
                this.editedIndex = this.allList.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.setShowAddEditDialog(true)
            },
            close() {
                this.setShowAddEditDialog(false);
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            },
            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setEdit({itemToEdit: this.editedItem, itemIndex: this.editedIndex});
                }
            },
            fileUploaded(fileAdded) {
                this.setSave(fileAdded);
            },
            fileDownload(downloadFile) {
                let fileUrl = downloadFile.file.url();
                let fileName = downloadFile.file.name();
                FileService.download(fileUrl, fileName);
            },
            showAddFileDialog(b) {
                this.setShowAddFileDialog(b);
            },
            paginate(page) {
                this.setPage(page);
            },
            searchAll() {
                this.setSearch(this.search);
            }
        },

    }
</script>
<style scoped>

</style>